import { Notification, Message as AMessage, Modal } from "@arco-design/web-vue";

export default () => {
  const Message = (options) => {
    const { type = "info", title = "" } = options || {};
    AMessage[type](title);
  };
  Message.info = (options) => Message({ ...options, type: "info" });
  Message.success = (options) => Message({ ...options, type: "success" });
  Message.warning = (options) => Message({ ...options, type: "warning" });
  Message.error = (options) => Message({ ...options, type: "error" });
  return {
    Notification,
    Message,
    Modal,
  };
};
